import React from "react";
import "../css-coding/WhyChooseUsPage.css";

// Icons (inline SVGs)
const TrophyIcon = ({ size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6" />
    <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18" />
    <path d="M4 22h16" />
    <path d="M10 14h4" />
    <path d="M12 10V6" />
    <path d="M15.4 17a3 3 0 0 0-4.8 0" />
  </svg>
);


const UsersIcon = ({ size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);


const CompassIcon = ({ size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <circle cx="12" cy="12" r="10" />
    <polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88" />
  </svg>
);

const ZapIcon = ({ size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
  </svg>
);


const WalletIcon = ({ size = 24, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M19 7V4a1 1 0 0 0-1-1H5a2 2 0 0 0 0 4h14a2 2 0 0 1 0 4H5a2 2 0 0 0 0 4h14v1a1 1 0 0 1-1 1H3" />
  </svg>
);


// Content data
const features = [
  {
    icon: TrophyIcon,
    heading: "Proven Track Record",
    text: "With 6000+ reels delivered, 60+ motion graphic presentations, 900+ social media posters, and 40+ social media accounts managed, our results speak for themselves."
  },
  {
    icon: UsersIcon,
    heading: "Expert Team",
    text: "Our founder bring years of expertise in video editing, motion graphics, and business strategy. Every team member is carefully selected and trained to maintain our high standards."
  },
  {
    icon: CompassIcon,
    heading: "Comprehensive Services",
    text: "From video editing and graphic design to social media management and personal branding, we offer end-to-end solutions for all your digital content needs."
  },
  {
    icon: UsersIcon,
    heading: "Client-Centric Approach",
    text: "We believe in building long-term relationships with our clients. Every project is treated with the utmost care and attention to detail."
  },
  {
    icon: CompassIcon,
    heading: "Transparent Communication",
    text: "Our structured communication process ensures that you're always informed about your project's progress. No surprises, no hidden costs just pure professionalism."
  },
  {
    icon: ZapIcon,
    heading: "Cutting-Edge Technology",
    text: "We use the latest software and techniques to ensure your content stands out in the competitive digital landscape."
  },
  {
    icon: WalletIcon,
    heading: "Affordable Excellence",
    text: "We believe that high-quality video editing should be accessible to all, from individual creators to large brands. Our pricing structure offers premium services at reasonable rates."
  }
];

// Feature block
const FeatureBlock = ({ icon: Icon, heading, text }) => (
  <div className="feature-block-cu">
    <div className="feature-header-group-cu">
      <div className="feature-icon-wrapper-cu"><Icon /></div>
      <h3 className="feature-title-cu">{heading}</h3>
    </div>
    <p className="feature-description-cu">{text}</p>
  </div>
);

const WhyChooseUsPage = () => {
  return (
    <div className="page-container-cu">
      <div className="title-section-cu">
        <h2 className="main-title-cu">Why Choose The Growth Secret Media?</h2>
      </div>

      <div className="main-content-section-cu">
        <div className="features-grid-cu">
          {features.map((feature, i) => (
            <FeatureBlock key={i} {...feature} />
          ))}
        </div>
      </div>
    
    </div>
       
  );
};

export default WhyChooseUsPage;
